/**
 * Generated API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const DeclarationStatus = {
    Pending: 'PENDING',
    Valid: 'VALID',
    Revoked: 'REVOKED'
} as const;
export type DeclarationStatus = typeof DeclarationStatus[keyof typeof DeclarationStatus];

